export default "__VITE_ASSET__CmNygDgm__"